

export function enforceDeliveryPerListingType<T>(rows: (T & { deliveryPerListing?: number | string })[])
{
  return rows.map(l => ({
    ...l,
    // String representation of number not successfully converted to Number by enforceListingTypes
    deliveryPerListing: l.deliveryPerListing === undefined ? undefined : Number(l.deliveryPerListing) }));
}